<template>
  <div class="row">
    <div class="col-12 g">
      <div class="card card-body">
        <h4>
          <i class="fa fa-toggle-on"></i>
          خصائص التطبيقات
        </h4>
        <p class="text-muted mb-0">
          تحكم في ظهور خصائص التطبيقات الجديدة حسب الإصدار والمنصة: تظهر في كل الإصدارات، أو تختفي نهائياً، أو تظهر / تختفي في إصدارات محددة.
          يصل التغيير للتطبيقات خلال دقيقة تقريباً (عند فتح الشاشة أو سحبها للتحديث).
        </p>
      </div>
    </div>

    <div v-for="(f, key) in features" :key="key" class="col-12 col-lg-8 g">
      <div class="card" v-if="config[key]">
        <div class="card-header">
          <div>
            <h5 class="mb-25">{{ f.name }} <small class="text-muted">— تطبيق {{ appName(f.app) }}</small></h5>
            <span class="text-muted">{{ f.description }}</span>
          </div>
          <span class="badge" :class="anyVisible(key) ? 'badge-light-success' : 'badge-light-secondary'">
            {{ anyVisible(key) ? 'ظاهرة' : 'مخفية' }}
          </span>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label>الظهور</label>
            <div v-for="m in modes" :key="m.key" class="custom-control custom-radio mb-50">
              <input :id="key + '-' + m.key" type="radio" class="custom-control-input" :value="m.key" v-model="config[key].mode">
              <label class="custom-control-label" :for="key + '-' + m.key">
                {{ m.label }} <small class="text-muted">{{ m.hint }}</small>
              </label>
            </div>
          </div>

          <div class="form-group" v-if="config[key].mode == 'only' || config[key].mode == 'except'">
            <label :for="key + '-versions'">
              {{ config[key].mode == 'only' ? 'الإصدارات التي تظهر فيها' : 'الإصدارات التي تختفي فيها' }}
            </label>
            <input :id="key + '-versions'" class="form-control" dir="ltr" placeholder="4.0.7, 4.0.8"
              :value="(config[key].versions || []).join(', ')" @change="setVersions(key, $event.target.value)">
            <small class="text-muted d-block mt-25">افصل بين الإصدارات بفاصلة. أو اختر من الإصدارات المثبتة عند المستخدمين:</small>
            <div class="mt-50">
              <button v-for="v in seen(f.app)" :key="v.version" type="button" class="btn btn-sm mr-50 mb-50"
                :class="config[key].versions.includes(v.version) ? 'btn-primary' : 'btn-outline-secondary'"
                @click="toggleVersion(key, v.version)">
                {{ v.version }} <small>({{ v.count }} جهاز)</small>
              </button>
              <span v-if="!seen(f.app).length" class="text-muted">لا توجد بيانات أجهزة بعد.</span>
            </div>
          </div>

          <div class="form-group" v-if="config[key].mode != 'none'">
            <label>المنصات</label>
            <div class="d-flex">
              <div v-for="p in platforms" :key="p.key" class="custom-control custom-checkbox mr-2">
                <input :id="key + '-p-' + p.key" type="checkbox" class="custom-control-input" :value="p.key" v-model="config[key].platforms">
                <label class="custom-control-label" :for="key + '-p-' + p.key"><i :class="p.icon"></i> {{ p.name }}</label>
              </div>
            </div>
          </div>

          <div class="alert alert-secondary g mb-1">
            <span class="text-dark">{{ summary(key) }}</span>
          </div>

          <button class="btn btn-primary" @click="save()" :disabled="saving || !loaded">
            <i class="fa fa-save"></i>
            {{ saving ? 'جاري الحفظ...' : 'حفظ' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      features: {},
      apps: {},
      config: {},
      stats: {},
      loaded: false,
      saving: false,
      modes: [
        { key: 'all', label: 'إظهار في كل الإصدارات', hint: '' },
        { key: 'none', label: 'إخفاء نهائياً', hint: '' },
        { key: 'only', label: 'إظهار في إصدارات محددة فقط', hint: '(مخفية في باقي الإصدارات)' },
        { key: 'except', label: 'إخفاء في إصدارات محددة فقط', hint: '(ظاهرة في باقي الإصدارات)' },
      ],
      platforms: [
        { key: 'android', name: 'أندرويد', icon: 'fa fa-android' },
        { key: 'ios', name: 'آيفون', icon: 'fa fa-apple' },
      ],
    };
  },
  created() {
    this.load();
  },
  methods: {
    appName(app) {
      return (this.apps[app] || {}).name || app;
    },
    // Versions installed on devices (Admin → إصدارات التطبيقات), newest first.
    seen(app) {
      var s = this.stats[app] || { versions: [] };
      return s.versions.map(function(v){
        return { version: v.version, count: ((v.android || {}).total || 0) + ((v.ios || {}).total || 0) };
      });
    },
    setVersions(key, text) {
      this.config[key].versions = [...new Set(text.split(/[\s,،]+/).map(function(v){ return v.trim(); }).filter(function(v){
        return /^\d{1,5}(\.\d{1,5}){0,3}$/.test(v);
      }))];
    },
    toggleVersion(key, v) {
      var list = this.config[key].versions;
      this.config[key].versions = list.includes(v) ? list.filter(function(x){ return x != v; }) : list.concat([v]);
    },
    anyVisible(key) {
      var c = this.config[key];
      return c.mode != 'none' && c.platforms.length > 0 && (c.mode != 'only' || c.versions.length > 0);
    },
    summary(key) {
      var c = this.config[key], g = this;
      if(!this.anyVisible(key)) return 'النتيجة: مخفية في كل الإصدارات.';
      var where = c.platforms.map(function(p){ return g.platforms.find(function(x){ return x.key == p; }).name; }).join(' و');
      var list = c.versions.join('، ');
      if(c.mode == 'all') return 'النتيجة: ظاهرة في كل إصدارات ' + where + '.';
      if(c.mode == 'only') return 'النتيجة: ظاهرة في ' + where + ' للإصدارات ' + list + ' فقط.';
      return 'النتيجة: ظاهرة في كل إصدارات ' + where + (list ? ' ما عدا ' + list : '') + '.';
    },
    load() {
      var g = this;
      $.post(api + '/admin/apps/features', { jwt: this.jwt }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.features = r.features;
        g.apps = r.apps;
        g.config = r.response;
        g.loaded = true;
      });
      $.post(api + '/admin/apps/stats', { jwt: this.jwt }).then(function(r){
        if(r.status == 100) g.stats = r.response;
      });
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + '/admin/apps/features/save', {
        jwt: this.jwt,
        config: JSON.stringify(this.config),
      }).then(function(r){
        g.saving = false;
        if(r.status != 100) return alert(r.response, 200);
        g.config = r.response;
        alert('تم الحفظ، يصل للتطبيقات خلال دقيقة تقريباً.', 100);
      }).fail(function(){
        g.saving = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
